import api from "@/services/api";

const state = {
  products: [],
  product: null,
  lowStock: [],
  movements: [],
};

const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
  },

  SET_PRODUCT(state, product) {
    state.product = product;
  },

  SET_LOW_STOCK(state, lowStock) {
    state.lowStock = lowStock;
  },

  SET_MOVEMENTS(state, movements) {
    state.movements = movements;
  },
};

const actions = {

  /* ================= GET ALL PRODUCTS ================= */
  async getProducts({ commit }) {
    try {
      const res = await api.get("/products");
      commit("SET_PRODUCTS", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching products:", error.message);
      throw error;
    }
  },

  /* ================= GET SINGLE PRODUCT ================= */
  async getProduct({ commit }, id) {
    try {
      const res = await api.get(`/products/${id}`);
      commit("SET_PRODUCT", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching product:", error.message);
      throw error;
    }
  },

  /* ================= CREATE PRODUCT ================= */
  async createProduct(_, payload) {
    try {
      const res = await api.post("/products", payload);
      return res.data;
    } catch (error) {
      console.error("Error creating product:", error.message);
      throw error;
    }
  },

  /* ================= UPDATE PRODUCT ================= */
  async updateProduct(_, { id, payload }) {
    try {
      const res = await api.put(`/products/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("Error updating product:", error.message);
      throw error;
    }
  },

  /* ================= DELETE PRODUCT ================= */
  async deleteProduct(_, id) {
    try {
      const res = await api.delete(`/products/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting product:", error.message);
      throw error;
    }
  },

  /* ================= LOW STOCK ================= */
  async getLowStock({ commit }) {
    try {
      const res = await api.get("/stock/low-stock");
      commit("SET_LOW_STOCK", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching low stock products:", error.message);
      throw error;
    }
  },

  /* ================= MANUAL STOCK ADJUSTMENT ================= */
  async adjustStock(_, payload) {
    try {
      const res = await api.post("/stock/adjust", payload);
      return res.data;
    } catch (error) {
      console.error("Error adjusting stock:", error.message);
      throw error;
    }
  },

  /* ================= STOCK MOVEMENT HISTORY ================= */
  async getMovements({ commit }, { productId } = {}) {
    try {
      const res = await api.get("/stock/movements", { params: { productId } });
      commit("SET_MOVEMENTS", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching stock movements:", error.message);
      throw error;
    }
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};